/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_Code_PlaceholderInputs */

const en_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const de_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const fr_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const es_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const it_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const nl_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const pl_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const fi_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const da_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

const sv_onboarding_verify_code_placeholder = /** @type {(inputs: Onboarding_Verify_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000000`)
};

/**
* | output |
* | --- |
* | "000000" |
*
* @param {Onboarding_Verify_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_code_placeholder = /** @type {((inputs?: Onboarding_Verify_Code_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_Code_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_code_placeholder(inputs)
	if (locale === "fr") return fr_onboarding_verify_code_placeholder(inputs)
	if (locale === "es") return es_onboarding_verify_code_placeholder(inputs)
	if (locale === "it") return it_onboarding_verify_code_placeholder(inputs)
	if (locale === "nl") return nl_onboarding_verify_code_placeholder(inputs)
	if (locale === "pl") return pl_onboarding_verify_code_placeholder(inputs)
	if (locale === "fi") return fi_onboarding_verify_code_placeholder(inputs)
	if (locale === "da") return da_onboarding_verify_code_placeholder(inputs)
	if (locale === "sv") return sv_onboarding_verify_code_placeholder(inputs)
	return en_onboarding_verify_code_placeholder(inputs)
});